import { AddressCollectionDataProvider } from '@steelbuy/data-provider';
import { AccountAddAddress } from '../../components/account-add-address/AccountAddAddress';

export const AccountAddAddressView = () => (
    <AddressCollectionDataProvider lazyLoad>
        <AccountAddAddress />
    </AddressCollectionDataProvider>
);
